import { Box, Button, CircularProgress, DialogContent, DialogTitle, FormControl, TextField, Typography } from "@mui/material";
import { IRole } from "../../../../interfaces/common/roles";
import CustomDialog from "../../../common/custom-dialog/custom-dialog"
import { useState } from "react";
import useRoles from "../../../../hooks/roles";
import { useSnackBar } from "../../../../contexts/snackbar";
import { usePermissions } from "../../../../hooks/permissions";
import { PermissionMatrix } from "./permission-matrix";
import { GlobalPermissions } from "./global-permissions";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Permission } from "../../../../interfaces/common/permissions";

interface RoleModalProps {
    onClose: () => void;
    defaultRole?: IRole;
    onSuccess: (r: IRole) => void;
    createRole: (role: RoleInput) => Promise<IRole | null>;
    updateRole: (id: number, updates: RoleInput) => Promise<IRole | null>;
    isLoading: boolean;
    permissions: Permission[]
}

export interface RoleInput { name: string; permission_ids: number[]; description: string;}

export const RoleModal = ({
    onClose,
    defaultRole,
    onSuccess,
    createRole,
    updateRole,
    isLoading,
    permissions
}: RoleModalProps) => {
    const [roleInput, setRuleInput] = useState<RoleInput>(defaultRole ? {name: defaultRole.name, description: defaultRole.description, permission_ids: defaultRole.permissions.map(item => item.id)} : {name: "", permission_ids: [], description: ""})
    const {showMessage} = useSnackBar();

    const [selectedPermissionIds, setSelectedPermissionIds] = useState<number[]>(
        defaultRole ? defaultRole.permissions.filter(p => !p.is_global).map((p) => p.id) : []
    );

    const [selectedGlobalPermissionIds, setSelectedGlobalPermissionIds] = useState<number[]>(
        defaultRole ? defaultRole.permissions.filter(p => p.is_global).map((p) => p.id) : []
    )


    console.log("selectedPermissionIds = ", selectedPermissionIds)
    console.log("selectedGlobalPermissionIds = ", selectedGlobalPermissionIds)
    const handleSubmit = async () => {
        try {
          let newRole : IRole | null = null
          const input = {
            ...roleInput,
            permission_ids: [...selectedPermissionIds, ...selectedGlobalPermissionIds],
          };
          if (defaultRole) {
            newRole = await updateRole(defaultRole.id, input);
          } else {
            newRole = await createRole(input);
          }
          if (!newRole) throw new Error("failed");
          else onSuccess(newRole);
        } catch {
          showMessage("Failed to save permission group.", "error");
        }
    };


    return <CustomDialog
            open={true}
            onClose={onClose}
            fullWidth
            maxWidth={"xl"}
         >
            <DialogTitle>
                <Typography align="center" variant="h4">{defaultRole ? "Edit Permission Group" : "New Permission Group"}</Typography>
            </DialogTitle>

            <DialogContent>

                
                    <form onSubmit={(e)=>{
                        e.preventDefault()
                        handleSubmit();  
                    }} style={{width: "100%", marginTop: 10, display: "flex", flexDirection: "column", alignContent: "center", alignItems: "center", gap: 10}}>
                        <FormControl sx={{maxWidth: 500}} fullWidth>
                            <TextField
                                fullWidth
                                value={roleInput.name}
                                label={"Group Name"}
                                placeholder="Provide a name for this permission group"
                                onChange={(e)=>setRuleInput({...roleInput, name: e.target.value})}
                                required
                                disabled={isLoading}
                            />
                        </FormControl>

                        <FormControl sx={{maxWidth: 500}} fullWidth>
                            <TextField
                                fullWidth
                                value={roleInput.description}
                                label={"Group Description"}
                                multiline
                                minRows={3}
                                placeholder="Optionally provide a description for the grouop. For example: Employees with limited access to accounting."
                                onChange={(e)=>setRuleInput({...roleInput, description: e.target.value})}
                                disabled={isLoading}
                            />
                        </FormControl>

                        {!isLoading && (
                           <Grid2 container spacing={5} mt={3} width={"100%"}>
                            <Grid2 xs={12} md={8}>
                                <PermissionMatrix
                                    permissions={permissions.filter(item => !item.is_global)}
                                    selectedIds={selectedPermissionIds}
                                    onChange={setSelectedPermissionIds}
                                />
                            </Grid2>
                           
                            <Grid2 xs={12} md={4}>
                                <GlobalPermissions
                                    permissions={permissions.filter(p => p.is_global)}
                                    selectedIds={selectedGlobalPermissionIds}
                                    onChange={setSelectedGlobalPermissionIds}
                                />
                            </Grid2>
                           </Grid2>
                           
                        )}

                        <Box margin={"auto"}>
                            <Button variant="contained" type={"submit"} disabled={isLoading}>Save {isLoading && <CircularProgress sx={{ml:2}} size={20} />}</Button>
                        </Box>
                    </form>



                

            </DialogContent>

        </CustomDialog>

}